import { httpClient } from "../http/httpClient";

export async function deleteConsultById(id: string): Promise<void> {
  await httpClient.delete(`/consults/${id}`);
}
